import { useState,useEffect } from "react";
import { instance } from '../../common';

const Cautions = (props) => {
  console.log('props : ', props)

  const [data, setData] = useState([]);
  useEffect(() => {
    instance.post('/rep_car/work_id', { r_id: props.r_id }).then((res) => {
      // console.log('car info is: ', res.data[0]);
      setData(res.data[0]);
    });
  }, []);

  const {suntint,blackbox,coating,ppf,detail,film} = data;
  return (
    <div className="mt-5 lastJuMargin">
      <div className="col-12 p-0 mt-5 mb-3 font-weight-bold chRyangTitle">
        주의사항 및 관리방법
      </div>
      {
        suntint 
        &&
        <div className="mt-5 font-weight-bold">
          <p className="mb-1">[썬팅]</p>
          <span>{suntint}</span>
        </div>
      }
      {
        blackbox 
        &&
        <div className="mt-5 font-weight-bold">
          <p className="mb-1">[블랙박스]</p>
          <span>{blackbox}</span>
        </div>
      }
      {
        coating 
        &&
        <div className="mt-5 font-weight-bold">
          <p className="mb-1">[유리막 코팅]</p>
          <span>{coating}</span>
        </div>
      }
      {
        ppf 
        &&
        <div className="mt-5 font-weight-bold">
          <p className="mb-1">[PPF]</p>
          <span>{ppf}</span>
        </div>
      }
      {
        detail 
        &&
        <div className="mt-5 font-weight-bold">
          <p className="mb-1">[디테일 코팅]</p>
          <span>{detail}</span>
        </div>
      }
      {
        film 
        &&
        <div className="mt-5 font-weight-bold">
          <p className="mb-1">[전명 유리 보호 필름]</p>
          <span>{film}</span>
        </div>
      }
      
    </div>
  );
};

export default Cautions;
